// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2xPSu","productName":"Table_productName__1O6Ll"};